import React from 'react';
import { QuestionPage } from './components/QuestionPage';
import './index.scss';

export default function Questions() {
  return <QuestionPage />;
}
